import { render, staticRenderFns } from "./ProductReviewRating.vue?vue&type=template&id=13972b4e&scoped=true&"
import script from "./ProductReviewRating.vue?vue&type=script&lang=js&"
export * from "./ProductReviewRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13972b4e",
  null
  
)

export default component.exports